// Components
import {
  Section,
  Select,
  SectionSkeleton,
} from '@zolteam/zol-admin-ui';

/**
 * ContentTranslationLanguage component.
 * @param {object} props
 * @param {boolean} [props.isloading=false]
 * @param {Array<{label:string, value:string}>} props.localesOptions
 * @param {string} props.currentLocale
 * @param {Function} props.handleLocaleChange
 * @param {string} props.sectionTitle
 * @param {string} props.selectLocalePlaceholder
 * @returns {JSX.Element}
 */
function ContentTranslationLanguage({
  isloading = false,
  localesOptions,
  currentLocale,
  handleLocaleChange,
  sectionTitle,
  selectLocalePlaceholder,
}) {
  return isloading
    ? <SectionSkeleton />
    : (
      <Section id="translation-section" title={sectionTitle}>
        <Select
          required
          id="translation"
          name="translation"
          placeholder={selectLocalePlaceholder}
          value={currentLocale}
          options={localesOptions}
          onChange={handleLocaleChange}
        />
      </Section>
    );
}

export default ContentTranslationLanguage;
